// src/pages/DoctorMyAvailabilityPage.jsx
// Route: /doctor/availability
//
// A doctor setting their own working hours and days off. No doctorId is
// passed anywhere here — DoctorAvailabilityEditor's "self" mode resolves the
// doctor server-side from the JWT, which is the whole reason the backend has
// a /me family of endpoints separate from the {doctorId} one: a doctor's own
// JWT identity (AuthContext's user.id) is a navigators.id, not the doctors.id
// this feature is keyed by, so the frontend can't safely supply an id here
// even if it wanted to.

import React from 'react';
import { AppShell } from '../components/Layout';
import DoctorAvailabilityEditor from '../components/DoctorAvailabilityEditor';

export default function DoctorMyAvailabilityPage() {
  return (
    <AppShell breadcrumbs={[{ label: 'My Availability' }]}>
      <DoctorAvailabilityEditor mode="self" />
    </AppShell>
  );
}
